import { render, staticRenderFns } from "./StudentPosterTitle.vue?vue&type=template&id=3a48e550&scoped=true&"
import script from "./StudentPosterTitle.vue?vue&type=script&lang=js&"
export * from "./StudentPosterTitle.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterTitle.vue?vue&type=style&index=0&id=3a48e550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48e550",
  null
  
)

export default component.exports